import React from "react";

const Topbar = () => {
  return (
    <div className="bg-secondary">
      <div className="container mx-auto my-1">
        {/* <p className="text-white font-bold md:text-lg text-center">Book free photoshoot</p> */}
      </div>
    </div>
  );
};

export default Topbar;
